const SELECTOR_DATA = {
  selectSizeTitle: {
    titleKey: 'PDP_SELECT_SIZE_TITLE',
    default: 'Brand’s Size:',
  },
  selectSizeText: {
    titleKey: 'PDP_SELECT_SIZE_TEXT',
    default: 'Select One',
  },
}

const MARK_DATA = {
  markText: {
    titleKey: 'PDP_SIZE_MARK_TEXT',
    default: 'Size runs large, we recommend to buy 1 size down',
  },
}

export { MARK_DATA, SELECTOR_DATA }
